import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "./useUser";

// Admin route guard. Same semantics as the user app's RequireAuth:
// while /me is loading, render nothing; on unauthenticated, redirect
// to /login preserving returnTo.
//
// 0016 Slice 1 — additionally redirects non-admin signed-in users to
// /no-access. The server-side gate (Admin middleware) is the source
// of truth — every admin endpoint 403s for non-admins. The frontend
// gate is a UX nicety so non-admins don't see broken empty pages.
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { data: user, isLoading } = useUser();
  const location = useLocation();

  if (isLoading) return null;
  if (!user) {
    const returnTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?returnTo=${returnTo}`} replace />;
  }
  if (!user.is_admin) {
    return <Navigate to="/no-access" replace />;
  }
  return <>{children}</>;
}
